import * as z from "zod";
import { attachmentSchema, dateSchema } from "./schemasComplex";
import { zRequiredString } from "./schemaUtils";

export const schemaFormEvent = z.object({
  name: zRequiredString("Veuillez dÃ©finir un nom").max(50, {
    message: "Maximum 50 caractÃ¨res",
  }),

  description: zRequiredString(
    "Veuillez dÃ©finir une description de l'Ã©vÃ©nement",
  ),
  firstMeasure: zRequiredString(
    "Veuillez dÃ©finir une mesure immÃ©diate Ã  prendre",
  ),
  site: zRequiredString("Veuillez dÃ©finir un site"),
  localisation: z.string().optional(),
  dateEvt: dateSchema,
  attachedFiles: attachmentSchema,
});
